export default __webpack_public_path__ + "static/lgbtq-pr-all-1-9846ef2247e2ab3b55086459a2115bb7.jpg";